import { render, staticRenderFns } from "./jyCfg.vue?vue&type=template&id=5ed07297&scoped=true"
import script from "./jyCfg.vue?vue&type=script&lang=js"
export * from "./jyCfg.vue?vue&type=script&lang=js"
import style0 from "./jyCfg.vue?vue&type=style&index=0&id=5ed07297&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed07297",
  null
  
)

export default component.exports